import React, { Component } from 'react'
import styled from 'styled-components'
import { media } from 'styled-bootstrap-grid'

const Wrapper = styled.div`
  position: absolute;
  bottom: 2rem;
  left: 2rem;
  z-index: 2;

  ${media.xs`
    bottom: 1rem;
    left: 1rem;
    transform: scale(0.8);
  `}
`

export default class IconPro extends Component {
  render() {
    return(
      <Wrapper>
        <svg
          width="172"
          height="88"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill="#FFF"
            fillRule="evenodd"
            d="M117.976562 62.3867188V25.6484375c0-7.1094105 2.646458-13.0663822 7.939454-17.87109375C131.209011 2.97263223 137.537073.5703125 144.900391.5703125s13.681614 2.40231973 18.955078 7.20703125c5.273464 4.80471155 7.910156 10.76168325 7.910156 17.87109375v36.7382813c0 7.1094105-2.636692 13.0663822-7.910156 17.8710937s-11.59176 7.2070313-18.955078 7.2070313-13.69138-2.4023198-18.984375-7.2070313c-5.292996-4.8047115-7.939454-10.7616832-7.939454-17.8710937zm5.332032.3515625c0 5.5859654 2.177712 10.3808393 6.533203 14.3847656 4.35549 4.0039262 9.374971 6.0058593 15.058594 6.0058593 5.683622 0 10.703103-2.0214641 15.058593-6.0644531 4.355491-4.0429889 6.533204-8.8183318 6.533204-14.3261718V25.296875c0-5.50784-2.177713-10.2831829-6.533204-14.3261719-4.35549-4.04298894-9.374971-6.0644531-15.058593-6.0644531-5.683623 0-10.703104 2.01169863-15.058594 6.0351562-4.355491 4.0234577-6.533203 8.8085661-6.533203 14.3554688v37.4414063zM98.2343758 1.9765625V86h5V1.9765625h-5zm-7.9958497 0H81.378907c-7.6172256 0-13.5839628 2.20700918-17.9003906 6.62109375-4.3164279 4.41408455-6.4746094 9.76559355-6.4746094 16.05468755 0 6.406282 1.8261536 11.5722459 5.4785156 15.4980468 3.652362 3.9258009 7.9003664 6.4550725 12.7441406 7.5878906L51.378907 86h6.09375l23.203125-37.4414062h9.5627441V1.9765625zm0 42.2460937h-8.2736816c-6.0156551 0-10.8007635-1.816388-14.3554688-5.4492187-3.5547052-3.6328307-5.3320312-8.2812217-5.3320312-13.9453125 0-5.1953385 1.7382639-9.5800603 5.2148437-13.1542969C70.9687681 8.0995915 75.8320007 6.3125 82.082032 6.3125h8.1564941v37.9101562zM0 86.0234375V2h21.9726562c7.9297272 0 14.27732 2.20700918 19.0429688 6.62109375C45.7812738 13.0351783 48.1640625 18.9530879 48.1640625 26.375c0 6.8750344-2.4218508 12.7148197-7.265625 17.5195312-4.8437742 4.8047116-11.1523049 7.2070313-18.9257813 7.2070313H5.2734375v34.921875H0zM5.2734375 46.765625h16.1132813c6.406282 0 11.5820115-1.9140434 15.5273437-5.7421875 3.9453322-3.8281441 5.9179687-8.6718457 5.9179687-14.53125 0-6.0937805-1.9140433-10.9765441-5.7421874-14.6484375-3.8281442-3.67189336-9.0234047-5.5078125-15.5859376-5.5078125H5.2734375V46.765625z"
          />
        </svg>
      </Wrapper>
    )
  }
}



// WEBPACK FOOTER //
// ./src/ui/components/modules/Grades/IconPro.js